import { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { activeRoles } from '../../services/roleService'
import { toast } from 'react-toastify'
import { SVG_NAME } from "../../constants/index"
import { Checkbox } from 'primereact/checkbox';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { permission, permissionPut } from 'services/permissionService'
import { handleLoader, handleNotFound } from 'redux/counterSlice'
import { useDispatch } from 'react-redux'
import { DataTable, DataTableExpandedRows, DataTableValueArray } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputSwitch } from 'primereact/inputswitch'

const Permission = () => {
    const dispatch = useDispatch();
    const {
        handleSubmit,
        setValue,
        formState: { errors },
        control
    } = useForm<any>({ defaultValues: {} })

    const [roleList, setRoleList] = useState([]);
    const [permissionList, setPermissionList] = useState<any>([]);
    const [user, setUser] = useState<any>({ id: 0 })
    const dropdownRef: any = useRef(null);
    let [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined | any>({});
    const [isDropdownOpen, setDropdownOpen] = useState(false);

    const handleDropdownToggle = () => {
        setDropdownOpen(!isDropdownOpen);
    };

    const getPermission = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await permission(user.id);
            let temp: any = {}
            result.forEach((permission: any) => {
                if (typeof permission.permissions !== "object") {
                    setValue(permission.key, permission.permissions)
                }
                else {
                    Object.keys(permission.permissions).forEach((data: any) => {
                        setValue(`permissions.${permission.key}.${data}`, permission.permissions[data])
                    })
                    setValue(permission.key, Object.values(permission.permissions).some((value) => value))
                    if (Object.values(permission.permissions).some((value) => value)) {
                        temp[permission.key] = Object.values(permission.permissions).some((value) => value)
                    }
                }
            });
            // setExpandedRows(temp);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            setPermissionList(result)

        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    useEffect(() => {
        const sidebar = document.getElementById('wrapper');

        const handleSidebarHover = () => {
            if (sidebar && sidebar.classList.contains('sidebar--open')) {
                dropdownRef.current?.hide();
            }
        };

        sidebar && sidebar.addEventListener('mouseover', handleSidebarHover);

        return () => {
            sidebar && sidebar.removeEventListener('mouseover', handleSidebarHover);
        };
    }, []);

    const onSubmit = async (data: any) => {
        let i: any;
        for (i in data) {
            if (i in data.permissions) {
                data[i] = data.permissions[i]
            }
        }
        delete data.permissions
        data.role_id = user.id
        data.is_active = true
        data.updated_by = localStorage.getItem("username")
        dispatch(handleLoader(true));
        try {
            const { result, error } = await permissionPut(data);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            toast.success(result.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            dispatch(handleLoader(false));
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    };

    const getActiveRole = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await activeRoles();
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            setRoleList(result);
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const onRowToggle = (e: any) => {
        setExpandedRows(e.data);
    };

    // jsx elements logic
    const booleanValue = (data: any, index: any) => {
        return (
            <span key={index}>
                {typeof (data.permissions) === "object" ? (
                    <div className="d-flex" key={index}>
                        <div className="col d-flex p-0 align-items-center">
                            {/* {data.key === "aggregate_dashboard" ? (
                                <i className={`fa-solid ${SVG_NAME[data.key]}-another-class me-2 mt-1`}></i>
                            ) : (
                                <i className={`fa-solid ${SVG_NAME[data.key]} me-2 mt-1`}></i>
                            )} */}
                            <span>{data.label}</span>
                        </div>
                        <div className="col flex p-0 align-items-center justify-content-end">
                            <Controller
                                name={data.key}
                                defaultValue={Object.values(data.permissions).some((value) => value)}
                                control={control}
                                render={({ field }) => (
                                    <InputSwitch
                                        {...field}
                                        checked={field.value}
                                        onChange={(e: any) => {
                                            field.onChange(e.value)
                                            handleSelectAllChange(e.target, data);
                                            let temp: any = {}
                                            temp[data.key] = e.target.value
                                            if (e.target.value) {
                                                setExpandedRows({ ...expandedRows, ...temp });
                                            } else {
                                                const asArray = Object.entries(expandedRows);
                                                const filtered = asArray.filter(([key, value]) => key !== e.target.name);
                                                const justStrings = Object.fromEntries(filtered);
                                                setExpandedRows(justStrings);
                                            }
                                        }}
                                        inputId={field.name}
                                    />
                                )}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="d-flex" key={index}>
                        <div className="col d-flex p-0 align-items-center">
                            {/* <i className={`fa-solid ${SVG_NAME[data.key]} me-2 mt-1`}></i> */}
                            <span>{data.label}</span>
                        </div>
                        <div className="col d-flex p-0 align-items-center justify-content-end">
                            <Controller
                                name={data.key}
                                control={control}
                                render={({ field }) => (
                                    <InputSwitch
                                        {...field}
                                        checked={field.value}
                                        disabled={data.key === "q_a" ? true : false}
                                        onChange={(e) => field.onChange(e.value)}
                                        inputId={field.name}
                                    />
                                )}
                            />
                        </div>
                    </div>
                )}
            </span>
        )
    }

    // child component
    const childComponent = (data: any) => {
        return (
            <div className="w-100">
                <div className='d-flex justify-content-between'>
                    {Object.keys(data.permissions).map((key: any) => (
                        <div className="d-flex flex-column" key={`${data.key}_${key}`}>
                            <label className="form-check-label text-center" htmlFor="flexCheckDefault">
                                {key.replace(/^./, key[0].toUpperCase())}
                            </label>
                            <Controller
                                name={`permissions.${data.key}.${key}`}
                                control={control}
                                defaultValue={data.permissions[key]}
                                render={({ field }) => (
                                    <Checkbox
                                        {...field}
                                        checked={field.value}
                                        onChange={(e) => {
                                            field.onChange(e.checked)
                                            handleChildPermissionChange(e.target, data, key);
                                        }}
                                        inputId={field.name}
                                    />
                                )}
                            />
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    // row expansion table
    const rowExpansionTemplate = (data: object) => {
        return (
            <DataTable value={[data]}>
                <Column header="" body={childComponent} />
                {/* <Column /> */}
            </DataTable>
        )
    }

    const allowExpansion = (rowData: any) => {
        return typeof (rowData.permissions) === "object"
    };

    const handleSelectAllChange = (e: any, permission: any) => {
        const updatedPermissions = { ...permission.permissions };
        for (const key in updatedPermissions) {
            updatedPermissions[key] = e.value;
            setValue(`permissions.${permission.key}.${key}`, e.value);
        }
        permission.permissions = updatedPermissions;
    };

    const handleChildPermissionChange = (e: any, permission: any, childKey: any) => {
        permission.permissions[childKey] = e.checked;
        const allChecked = Object.values(permission.permissions).some((value) => value === true);
        setValue(permission.key, allChecked);
    };

    const handleUserListChange = async (e: DropdownChangeEvent) => {
        setUser(e.value)
        setExpandedRows({})
    }

    useEffect(() => {
        dispatch(handleNotFound(false))
        getActiveRole();
    }, [])

    useEffect(() => {
        getPermission();
    }, [user])

    return (
        <div className='p-4 content-wrapper'>
            <div className="switch-section user-management-section set-permission-main">
                <div className="round_bg mb-4" style={{ position: "relative" }}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='set-permission-wrap'>
                            <div className="set-permission-top table-top-row">
                                <h4 className="mb-0">Permission Management</h4>
                                <div className='set-permission-top-right table-right-row'>
                                    <div className='search-select table-right-first mr-3 mt-1 mb-1'>
                                        <Controller
                                            name="role_id"
                                            control={control}
                                            defaultValue={null} // Set your initial value here
                                            rules={{ required: 'Please select a role' }} // Add validation rules here
                                            render={({ field }) => (
                                                <Dropdown
                                                    ref={dropdownRef}
                                                    id="role_id"
                                                    value={user}
                                                    onChange={(e) => {
                                                        handleUserListChange(e)
                                                        field.onChange(e.target.value)
                                                    }}
                                                    // onShow={handleDropdownToggle} // Event fired when dropdown opens
                                                    // onHide={handleDropdownToggle}
                                                    options={roleList}
                                                    optionLabel="name"
                                                    placeholder="Select Role"
                                                    filter
                                                    filterPlaceholder='Search role'
                                                    className={`outline-select table-search ${isDropdownOpen ? 'dropdown-open' : ''}`}
                                                    style={{ position: "relative" }}
                                                />
                                            )}
                                        />
                                        {errors.role_id && <p className="text-danger mb-0">{'Please select a role'}</p>}
                                    </div>
                                    <div className='table-right-end mt-1 mb-1'>
                                        <button className="outline-active-btn" type="submit" >Save</button>
                                    </div>
                                </div>
                            </div>
                            <div className="set-permission-table-wrap">
                                <div className='permission-table-head'>
                                    <h6>Set Permission</h6>
                                </div>
                                <div className="set-permission-table">
                                    <DataTable value={permissionList} rowExpansionTemplate={rowExpansionTemplate} expandedRows={expandedRows} onRowToggle={onRowToggle}
                                        dataKey="key">
                                        <Column header="" body={booleanValue} />
                                        <Column expander={allowExpansion} />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                        {/* <div className="p-3 p-sm-4 settings-actions" style={{ background: "#EAEAEA" }}>
                            <div className="d-sm-flex align-items-center justify-content-between">
                                <p className="mb-0"><strong>NOTE:</strong> The changes you made in the settings will be reflected after you login again.</p>
                                <button className="btn btn-primary ms-sm-2 mt-3 mt-sm-0" type="submit" >Save</button>
                            </div>
                        </div> */}
                    </form>
                </div>
                <p className="mb-0 fix-note"><strong>NOTE:</strong> The changes you made in the settings will be reflected after you login again.</p>
            </div>
        </div>
    )
}

export default Permission